import { LANGUAGES, LANGUAGE_NAMES } from '@praesto/shared'
import { useLanguage, useText } from '../i18n.js'

/**
 * Sprachwahl als Knopfreihe.
 *
 * Kein Auswahlfeld: Bei zwei Sprachen wäre ein Menü ein Klick mehr für dasselbe
 * Ergebnis. Die Sprachen stehen in sich selbst benannt da — wer die Oberfläche
 * gerade nicht lesen kann, erkennt „English" trotzdem.
 *
 * Der Umschalter merkt die Wahl am Gerät; ob sie zusätzlich ans Konto geht,
 * entscheidet der Aufrufer über `onChange` — der Anmeldebildschirm hat noch
 * kein Konto, in das er schreiben könnte.
 */
export function LanguageSwitch({
  onChange,
}: {
  onChange?: (language: (typeof LANGUAGES)[number]) => void
}): React.ReactElement {
  const { language, setLanguage } = useLanguage()
  const t = useText()

  return (
    <div className="language-switch" role="group" aria-label={t('common.language')}>
      {LANGUAGES.map((candidate) => (
        <button
          key={candidate}
          type="button"
          className={`button link${candidate === language ? ' is-active' : ''}`}
          aria-pressed={candidate === language}
          onClick={() => {
            setLanguage(candidate)
            onChange?.(candidate)
          }}
        >
          {LANGUAGE_NAMES[candidate]}
        </button>
      ))}
    </div>
  )
}
